import { Field, Form } from "react-final-form";
import React, { Component } from "react";
import styles, { Link } from "./styles";

import Button from "Components/Button";
import { FormError } from "Themes/StyledComponents";
import FormInput from "Components/FormInput/FormInput";
import LoadingIcon from "Components/LoadingIcon";
import navRoutes from "Navigation/NavRoutes";
import { withStyles } from "@material-ui/styles";

const validate = (values) => {
  const errors = {};
  if (!values.email) {
    errors.email = "Required";
  }
  if (!values.password1) {
    errors.password1 = "Required";
  }
  if (!values.first_name) {
    errors.first_name = "Required";
  }
  return errors;
};

class RegisterForm extends Component {
  render() {
    const { handleSubmit, error, history, fetching } = this.props;
    return (
      <Form
        validate={validate}
        onSubmit={handleSubmit}
        render={({ handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <Field
              name={"email"}
              component={FormInput}
              placeholder={"Choose a Username"}
              type={"text"}
              inputClass={"email"}
            />
            <Field
              name={"password1"}
              placeholder={"Password"}
              render={(props) => <FormInput type={"password"} {...props} />}
            />
            <Field
              name={"first_name"}
              component={FormInput}
              placeholder={"Display Name"}
            />
            {error && <FormError>{error}</FormError>}
            <Button type="submit" className={"signupButton"}>
              {fetching ? <LoadingIcon /> : "Get started"}
            </Button>
            <Link onClick={() => history.push(navRoutes.login)}>
              Already have an account? Login
            </Link>
          </form>
        )}
      />
    );
  }
}

export default withStyles(styles)(RegisterForm);
